import { Component, Input, OnInit } from '@angular/core';
import { BoobleModalService } from 'booble-modal';
import { InboundOrderDto } from 'src/app/domain/models/dto/inbound-order.dto';
import { Clipboard } from '@angular/cdk/clipboard';
import { NotifierService } from 'angular-notifier';
import { AttachInvoiceModalComponent } from 'src/app/pages/orders/shared/components/modals/attach-invoice-modal/attach-invoice-modal.component';
import { AuthenticationService } from 'src/app/shared/services';
import { MatBottomSheet } from '@angular/material/bottom-sheet';
import { OrdersService } from 'src/app/shared/services/orders.service';
import { Subject, takeUntil } from 'rxjs';

@Component({
  selector: 'app-order-payment',
  templateUrl: './order-payment.component.html',
  styleUrls: ['./order-payment.component.scss'],
})
export class OrderPaymentComponent implements OnInit {
  @Input() order: any;
  boobleModalData: InboundOrderDto;
  private readonly notifier: NotifierService;
  paymentType: string = '';
  isMobile = false;
  private destroy$ = new Subject<void>();

  get companyId() {
    return +this.accountService.getCompanyId();
  }

  get individualId() {
    return +this.accountService.getIndividualId();
  }

  constructor(
    private modalService: BoobleModalService,
    private readonly accountService: AuthenticationService,
    private ordersService: OrdersService,

    private clipboard: Clipboard,
    private bottomSheet: MatBottomSheet,
    notifierService: NotifierService
  ) {
    this.notifier = notifierService;
  }

  ngOnInit() {
    this.isMobile = window.innerWidth <= 820 ? true : false;

    if (this.isMobile) {
      this.boobleModalData = this.order;
    }

    if (typeof this.boobleModalData === 'number') {
      this.ordersService
        .getClientOrderById(this.boobleModalData)
        .pipe(takeUntil(this.destroy$))
        .subscribe({
          next: (result) => {
            this.boobleModalData = result.data;
          },
          error: () => {},
        });
    }
  }

  closeModal() {
    if (this.isMobile) {
      this.bottomSheet.dismiss();
    } else {
      this.modalService.dismiss(null);
    }
  }

  copyText(text: string) {
    this.clipboard.copy(text);
    this.notifier.notify('success', 'Texto copiado para área de transferência');
  }

  openAttachInvoiceModal(order: InboundOrderDto) {
    if (this.isMobile) {
      this.bottomSheet.dismiss();
    }
    this.modalService.present(AttachInvoiceModalComponent, order);
  }
}
